import React from 'react';
import CarSelectSearch, { IModel } from 'components/SearchBlock/CarSearch/CarSelectSearch';
import { ITranslations, IUrls } from 'components/SearchBlock/SearchBlock';
import LicencePlateSearch from 'components/SearchBlock/CarSearch/LicencePlate/LicencePlateSearch';

export interface IVehicle {
    manufacturer?: IModel;
    model?: IModel;
    type?: IModel;
    licence?: string;
}

interface IProps {
    viewType: string;
    labels: ITranslations;
    urls: IUrls;
    selectedVehicle?: IVehicle;
    setSelectedVehicle: (vehicle?: IVehicle) => void;
}

const CarSearchBlock = (props: IProps) => {
    const { viewType, labels, selectedVehicle, setSelectedVehicle, urls } = props;

    return (
        <React.Fragment>
            <LicencePlateSearch
                viewType={viewType}
                labels={labels}
                urls={urls}
                iconName={'license_est'}
                selectedVehicle={selectedVehicle}
                setSelectedVehicle={setSelectedVehicle}
            />
            <CarSelectSearch
                viewType={viewType}
                labels={labels}
                urls={urls}
                selectedVehicle={selectedVehicle}
                setSelectedVehicle={setSelectedVehicle}
            />
        </React.Fragment>
    );
};

export default CarSearchBlock;
